module.exports = __webpack_public_path__ + "static/media/checkbox-cumul.bbc93788.svg";